<template>
  <div class="container" v-title :data-title="$t('i18n.billingRecord')">
    <div id="outer-title">{{ $t("i18n.billingRecord") }}</div>
    <div v-loading="loading">
      <jl-table
        :tableData="tableData"
        @handleEdit="handleEdit"
        @handleDelete="handleDelete"
        @getEditData="getEditData"
        @init="init"
        :options="options"
        :columns="columns"
        :operates="operates"
        :total="total"
        :height="$defined.HEIGHT - 360 + 'px'"
      >
      </jl-table>
    </div>
  </div>
</template>
<script>
import { reactive, toRefs, getCurrentInstance } from "vue";
import { useI18n } from "vue-i18n";
import { useRouter } from "vue-router";
import jlTable from "../../components/table";
export default {
  name: "BillingBoard",
  components: {
    jlTable,
  },
  setup(props, { emit }) {
    emit("public_header", true);
    const { proxy } = getCurrentInstance();
    const { t } = useI18n();
    const router = useRouter();
    const state = reactive({
      formInline: {
        pageNumber: 1,
        pageSize: 10,
      },
      // table数据
      tableData: [],
      options: {
        // table 的参数
        isAdd: proxy.$defined.btnPermission("添加开票记录"), // 是否启用新增功能
        isEdit: proxy.$defined.btnPermission("编辑开票记录"), // 是否启用编辑功能
        isDelete: proxy.$defined.btnPermission("删除开票记录"), // 是否启用删除功能
        highlightCurrentRow: false, // 是否支持当前行高亮显示
        multiSelect: false, // 是否支持列表项选中功能
        pageShow: true, // 是否翻页
      },
      columns: [
        // 需要展示的列
        {
          prop: "billNo",
          label: "invoiceNo",
          align: "center",
          search: true,
          type: "input",
          rules: [{ required: true, message: t("i18n.input") }],
        },
        {
          prop: "upkeepContractNumber",
          label: "maintenanceContractNo",
          align: "center",
          search: true,
          type: "remote",
          props: { label: "number", value: null },
          loading: false,
          data: [],
          remoteMethod: (val) => {
            remoteMethod(val, "columns", "upkeepContractNumber");
          },
          formatter: (row) => {
            return row.upkeepType
              ? `<a>${row.upkeepContractNumber}</a>`
              : `<span>${row.upkeepContractNumber}</span>`;
          },
          method: (row) => {
            let page = row.upkeepType == 10 ? "Viewupdate" : "Viewcou";
            if (row.upkeepType) {
              router.push({
                path: "/upkeepContract/upkeepContract" + page,
                query: { id: row.upkeepContractId },
              });
            }
          },
          rules: [{ required: true, message: t("i18n.input") }],
        },
        {
          prop: "elevatorNumber",
          label: "elevatorNo",
          align: "center",
          search: false,
          row: false,
        },
        {
          prop: "billingDate",
          label: "billingDate",
          align: "center",
          search: false,
          type: "date",
          rules: [{ required: true, message: t("i18n.input") }],
          formatter: (row) => {
            return row.billingDate.split(" ")[0];
          },
        },
        {
          prop: "billValue",
          label: "invoiceAmount",
          align: "center",
          search: false,
          type: "input",
          rules: [{ required: true, message: t("i18n.input") }],
        },
        {
          prop: "days",
          label: "aging",
          align: "center",
          search: false,
          row: false,
        },
        {
          prop: "createdBy",
          label: "drawer",
          align: "center",
          search: false,
          row: false,
        },
        {
          prop: "matters",
          label: "relatedIssues",
          align: "left",
          width: 200,
          search: false,
          type: "input",
        },
      ],
      operates: {
        // 列操作按钮
        width: 140,
        fixed: "right",
        list: [
          {
            id: "1",
            label: "export",
            icon: "el-icon-upload2",
            class: "export",
            show: proxy.$defined.btnPermission("导出开票记录"),
            type: "outer",
            method: (formInline) => {
              exportBills(formInline);
            },
          },
        ],
      },
      total: 0,
      loading: true,
      editData: {},
    });

    const init = async (params) => {
      state.loading = true;
      params.upNumber = params.upkeepContractNumber || "";
      const { data } = await proxy.$api.maintenance.getBillsPage(params);
      state.tableData = data.records;
      state.total = data.total;
      state.loading = false;
    };

    const handleEdit = async (val, pages) => {
      // 新增/编辑数据
      let msg = val.id ? "edit" : "new";
      if (val.id) {
        for (let k in val) {
          if (val[k] !== undefined) {
            state.editData[k] = val[k];
          }
        }
        val = JSON.parse(JSON.stringify(state.editData));
      }
      if (val.upkeepContractNumber instanceof Object) {
        val.upkeepContractId = val.upkeepContractNumber.id;
        delete val.upkeepContractNumber;
      }
      val.billingDate = proxy.$defined.format(val.billingDate) + " 00:00:00";
      val.id
        ? await proxy.$api.maintenance.editBills(val.id, val)
        : await proxy.$api.maintenance.addBills(val);
      proxy.$defined.tip(t("i18n." + msg) + t("i18n.success"), "success");
      // 初始化 刷新
      init(pages);
    };

    const handleDelete = (row, pages) => {
      proxy.$api.maintenance.delBillOrCollect(row.id, 10).then(() => {
        init(pages);
        proxy.$defined.tip(t("i18n.delete") + t("i18n.success"), "success");
      });
    };

    const getEditData = (row) => {
      state.editData = row;
    };

    const exportBills = async (formInline) => {
      // 导出
      let obj = {};
      obj.billNo = formInline.billNo || "";
      obj.upNumber = formInline.upkeepContractNumber || "";
      state.operates.list[0].loading = true;
      let res = await proxy.$api.maintenance.exportBills(obj);
      proxy.$defined.exportFunc(res);
      state.operates.list[0].loading = false;
    };

    const remoteMethod = (val, column, key) => {
      var index = state[column].findIndex((item) => {
        return item.prop === key;
      });
      if (val) {
        state[column][index].loading = true;
        setTimeout(() => {
          proxy.$api.system.getContractData({ number: val }).then((data) => {
            state[column][index].data = data.data;
            state[column][index].loading = false;
          });
        }, 1000);
      } else {
        state[column][index].data = [];
      }
    };

    return {
      ...toRefs(state),
      handleEdit,
      init,
      handleDelete,
      remoteMethod,
      getEditData,
      exportBills,
    };
  },
};
</script>
